module.exports = "/images/kh.svg?a96be69c479b535494f9a30ddc0f9dd6";